import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setFile } from "../redux/creators/fileCreators";
import styled from "styled-components";

export default function UploadButton() {
  const dispatch = useDispatch();
  const { selectedProduct } = useSelector((state) => state.threekit);

  const addFile = (file) => dispatch(setFile(file));
  const fileInput = React.createRef();
  new URL(location.href).searchParams.get("imgRender");
  const params = new URL(location.href).searchParams;
  const urlImageRender = params.get("imgRender");
  const fileInputs = document.querySelector("#threekit-fileupload");
  if (urlImageRender != null) {
    function toDataUrl(url, callback) {
      var xhr = new XMLHttpRequest();
      xhr.onload = function () {
        var reader = new FileReader();
        reader.onloadend = function () {
          callback(reader.result);
        };
        reader.readAsDataURL(xhr.response);
      };
      xhr.open("GET", url);
      xhr.responseType = "blob";
      xhr.send();
    }
    toDataUrl(urlImageRender.split("?")[0], function (myBase64) {
      //console.log(myBase64); // myBase64 is the base64 string
      urltoFile(myBase64, "a.png").then(function (file) {
        const dataTransfer = new DataTransfer();
        dataTransfer.items.add(file);
        fileInputs.files = dataTransfer.files;
        fileInputs.dispatchEvent(new Event("change", { bubbles: true }));
      });
    });
  }

  function urltoFile(url, filename, mimeType) {
    mimeType = mimeType || (url.match(/^data:([^;]+);/) || "")[1];
    return fetch(url)
      .then(function (res) {
        return res.arrayBuffer();
      })
      .then(function (buf) {
        return new File([buf], filename, { type: mimeType });
      });
  }
  return (
    <Container>
      <ButtonContainer>
        <Label>
          {selectedProduct.available ? "Upload Your Image" : "Out of Stock"}
          <Input
            id="threekit-fileupload"
            type="file"
            name="fileupload[]"
            multiple="multiple"
            disabled={!selectedProduct.available}
            className={!selectedProduct.available ? "disabledButton" : ""}
            accept="image/png, image/jpg, image/jpeg"
            ref={fileInput}
            onChange={(e) => addFile(e.target.files[0])}
          />
        </Label>
      </ButtonContainer>
    </Container>
  );
}

const Label = styled.label`
  font-family: "sofia-pro";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 20px;
  color: white;
  width: 100%;
  padding: 17px;
  text-align: center;
  cursor: pointer;
`;
const Input = styled.input`
  display: none;
`;
const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: #c20754;
`;
const Container = styled.div`
  width: 100%;
  padding-bottom: 24px;
`;
